import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { PlanyardService } from 'src/app/modules/planyard/planyard.service';
import { SnackbarComponent } from '../snackbar/snackbar.component';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-vendor-settings',
  templateUrl: './vendor-settings.component.html',
  styleUrls: ['./vendor-settings.component.scss']
})
export class VendorSettingsComponent implements OnInit,OnDestroy {
  @Input() vendor:any
  spin: boolean =false;
  @Output() close: EventEmitter<any> = new EventEmitter();
  private destroy$ = new Subject<void>();
  vendorSettingForm: FormGroup = new FormGroup({
    id:new FormControl(""),
    name: new FormControl(""),
    address1: new FormControl(""),
    phone: new FormControl(""),
    email: new FormControl(""),
    leadDays: new FormControl(),
    purchaseDays: new FormControl(60),
    safetyStock: new FormControl(),
  });
  address: { [key: string]: string };
  addressTypes = [
    { key: "address1", type: "street_number" },
    { key: "address1", type: "route" },
    { key: "address1", type: "neighborhood" },
    { key: "address2", type: "sublocality_level_2" },
    { key: "address2", type: "sublocality_level_1" },
    { key: "address2", type: "locality" },
    { key: "city", type: "administrative_area_level_2" },
    { key: "state", type: "administrative_area_level_1" },
    { key: "postal", type: "postal_code" },
    { key: "country", type: "country" },
  ];
  constructor( private planyardService: PlanyardService,
    private snackBar: MatSnackBar) { }

  ngOnInit(): void {
    this.vendorSettingForm.patchValue(this.vendor);
    this.address = {
      address1: this.vendor.address1,
      address2: this.vendor.address2,
      city: this.vendor.city,
      state: this.vendor.state,
      postal: this.vendor.postal,
      country: this.vendor.country,
    };
  }

  save() {
    this.spin = true;
    let payload = this.vendorSettingForm.value;
    payload = { ...payload, ...this.address };
    this.planyardService.SaveVendor(payload).pipe(takeUntil(this.destroy$)).subscribe({
      next: (e) => {
        this.snackBar.openFromComponent(SnackbarComponent,
          {
            duration: 3000,
            horizontalPosition: 'center',
            data: {
              title: `Vendor added successfully`,
              action: 'Dismiss',
              type: 'success',
            },
          }
      );
      this.spin = false;
    },
     complete:() =>{
      this.spin = false;
      this.snackBar.openFromComponent(SnackbarComponent,
        {
          duration: 3000,
          horizontalPosition: 'center',
          data: {
            title: `Something went wrong`,
            action: 'Dismiss',
            type: 'error',
          },
        }
      );
     }
   });
  }

  cancel(){
    this.close.emit(true);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }
}
